<div fxLayout="column" fxLayoutGap="5px" fxFlex>
	<h2 mat-dialog-title>Your Coupons</h2>

	<div fxFlex="100%">
		<div fxLayout="column" fxLayoutAlign="space-evenly stretch" fxLayoutGap="10px" fxFlex="100%">
			<table mat-table [dataSource]="listData">

				<!-- Coupon Number -->
				<!-- <ng-container matColumnDef="coupon_number">
					<th id="id_coupon_number" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_COUPON_NUMBER' | translate}}</th>
					<td [id]="'id_coupon_number_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						{{ element?.code }}
					</td>
				</ng-container> -->

				<!-- Campaign -->
				<ng-container matColumnDef="campaign">
					<th id="id_campaign" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_CAMPAIGN_PLAIN' | translate}}</th>
					<td [id]="'id_campaign_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						{{ element?.campaign }}
					</td>
				</ng-container>

				<!-- Brand Name -->
				<!-- <ng-container matColumnDef="brand_name">
					<th id="id_brand_name" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_BRAND_NAME' | translate}}</th>
					<td [id]="'id_brand_name_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						{{ element?.brand }}
					</td>
				</ng-container> -->

				<ng-container matColumnDef="quantity">
					<th id="id_quantity" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_QUANTITY' | translate}}</th>
					<td [id]="'id_quantity' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						{{ element?.generated_quantity }} / {{ element?.max_quantity }}
					</td>
				</ng-container>

				<ng-container matColumnDef="product_names">
					<th id="id_product_names" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_PRODUCT_NAME' | translate}}</th>
					<td [id]="'id_product_names_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						<p *ngFor="let product_name of element.product_names" class="m-0">
							{{ product_name }}
						</p>
					</td>
				</ng-container>

				<!-- Expiration Date -->
				<!-- <ng-container matColumnDef="expiration_date">
					<th id="id_expiration_date" mat-header-cell *matHeaderCellDef>{{'TBL_HDR_EXPIRATION_DATE' | translate}}</th>
					<td [id]="'id_expiration_date_' + (i+1)" mat-cell *matCellDef="let element; let i = index"> 
						{{ element?.expiry_date }}
					</td>
				</ng-container> -->

				<!-- Actions Column -->
				<ng-container matColumnDef="actions">
					<th mat-header-cell *matHeaderCellDef> Actions </th>
					<td mat-cell *matCellDef="let element">
						<button mat-flat-button color="primary">Download QR Code</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			</table>
		</div>
	</div>

	<div *ngIf="!error && !loading && !listData?.length" fxFlex fxLayout="column" fxLayoutAlign="center center">
		<mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
		<span class="mat-body" [class.compact-header-text]="media.isActive('lt-sm')">
			{{ 'LABEL_NO_DATA' | translate}}
		</span>
	</div>
	 
	<div *ngIf="error && !loading && !listData?.length" fxLayoutGap="20px" fxFlex fxLayout="column"
		fxLayoutAlign="center center">
		<mat-icon color="warn" svgIcon="alert-circle-outline" class="size-48"></mat-icon>
		<span class="mat-body">
			{{ 'MSG_ERROR_NETWORK_CONNECTION' | translate }}
		</span>
		<button color="primary" mat-raised-button (click)="getData()">
			{{ 'LABEL_RETRY' | translate }}  
		</button>
	</div>
	  
	<div *ngIf="loading" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-report">
		<mat-spinner></mat-spinner>
	</div>

	<div fxFlex fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end">
		<button mat-button (click)="dialogRef.close(null)" type="button">{{ 'LABEL_CLOSE' | translate }}</button>
	</div>

</div>